import React from 'react';
import PropTypes from 'prop-types';

import injectSheet from 'react-jss';
import moment from 'moment';

const { arrayOf, object, shape, string } = PropTypes;

const styles = {
  container: {
    position: 'relative',
    // overflowY: 'auto',
    '&:before': {
      background: 'rgb(189, 189, 189)',
      content: '""',
      display: 'block',
      height: '90%',
      left: '11px',
      position: 'absolute',
      top: '10px',
      width: '2px',
      zIndex: '0',
    },
  },
  item: {
    cursor: 'pointer',
    display: 'flex',
    left: '2px',
    position: 'relative',
    '&:not(:first-child)': {
      marginTop: '20px',
    },
  },
  marker: {
    display: 'block',
    marginRight: '10px',
    position: 'relative',
    '& svg': {
      display: 'block',
      color: 'rgb(0, 188, 212)',
      fill: 'rgb(0, 188, 212)',
      height: '20px',
      width: '20px',
      userSelect: 'none',
      transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
      fontSize: '24px' },
  },
  content: {
    display: 'block',
  },
};

const Timeline = ({ classes, feed, onItemClick }) =>
  <div className={classes.container}>
    { feed.map((d, i) =>
      <div key={i} className={classes.item} onClick={() => onItemClick(i)}>
        <div className={classes.marker}>
          <svg viewBox="0 0 20 20">
              <circle cx="10" cy="10" r="8"/>
          </svg>
        </div>
        <div className={classes.content}>
          <div style={{ color: '#a5a5a5', display: 'block', fontSize: '12px' }}>{moment(d.timestamp).clone().fromNow()}</div>
          <div style={{ display: 'block', fontSize: '14px' }}>{d.label}</div>
        </div>
      </div>
    )}
  </div>;

Timeline.propTypes = {
  classes: object,
  feed: arrayOf(shape({
    label: string.isRequired,
    timestamp: string.isRequired,
  })).isRequired,
};

export default injectSheet(styles)(Timeline);



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/widgets/timeline.jsx